import styled from 'styled-components'
import { tabletBreakpoint } from 'react-components'

export const SectionContainer = styled.section`
    padding-top: 3.8rem;
    margin-top: -3.8rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding-top: 4.8rem;
        margin-top: -4.8rem;
    }
`
